var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStore8312761({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_37063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8281 24H5.67188C2.95795 24 0.75 21.792 0.75 19.0781V4.92188C0.75 2.20795 2.95795 0 5.67188 0H19.8281C22.542 0 24.75 2.20795 24.75 4.92188V19.0781C24.75 21.792 22.542 24 19.8281 24Z",
    fill: "#00C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8281 0H12.75V24H19.8281C22.542 24 24.75 21.792 24.75 19.0781V4.92188C24.75 2.20795 22.542 0 19.8281 0Z",
    fill: "#00AAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13966 18.4929C7.92286 18.8684 7.52813 19.0785 7.1228 19.0786C6.9241 19.0786 6.72291 19.0281 6.53883 18.9218C5.97924 18.5988 5.78682 17.8807 6.10988 17.3211L6.34036 16.9219H9.04669L8.13966 18.4929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92969 15.9843C5.28352 15.9843 4.75781 15.4586 4.75781 14.8124C4.75781 14.1662 5.28352 13.6405 5.92969 13.6405H8.23491L11.3968 8.16394L10.5399 6.67969C10.2168 6.1201 10.4092 5.40197 10.9688 5.07886C11.5284 4.7558 12.2466 4.94827 12.5696 5.50782L12.75 5.82024L12.9304 5.50786C13.2536 4.94822 13.9717 4.75585 14.5312 5.07891C14.8022 5.23543 14.9962 5.48813 15.0772 5.79047C15.1582 6.09282 15.1166 6.40866 14.9601 6.67974L10.9412 13.6405H13.4762L14.8294 15.9843H5.92969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5701 15.9842H18.618L19.3897 17.3209C19.7128 17.8804 19.5204 18.5985 18.9609 18.9216C18.7803 19.0259 18.5798 19.0792 18.3768 19.0792C18.275 19.0792 18.1726 19.0658 18.0716 19.0387C17.7692 18.9577 17.5165 18.7638 17.36 18.4926L13.291 11.4451L14.6442 9.10132L17.2649 13.6405H19.5701C20.2163 13.6405 20.742 14.1662 20.742 14.8123C20.742 15.4585 20.2163 15.9842 19.5701 15.9842Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 13.6406V15.9844H14.8294L13.4762 13.6406H12.75Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0772 5.79046C14.9961 5.48811 14.8022 5.23536 14.5312 5.07889C13.9717 4.75583 13.2535 4.94816 12.9304 5.50785L12.75 5.82022V10.5077L14.9601 6.67972C15.1166 6.40864 15.1582 6.09285 15.0772 5.79046Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_37063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore8312761);
export default __webpack_public_path__ + "static/media/app-store_831276 1.9c1eec0a323e5a0aaee12e187432a7a2.svg";
export { ForwardRef as ReactComponent };